import React, { Component } from "react";
import $ from "jquery";
import { withRouter } from "react-router";
import { ToastContainer } from "react-toastr";

class RejectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remark: "",
    };
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  async _handleSubmit(e) {
    e.preventDefault();
    this.props.reject(this.state.remark);
    $("#close-button-reject").click();
  }

  render() {
    return (
      <div style={{ maxWidth: "75%" }} className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              Please Provide reason for the rejection
            </h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <ToastContainer
              ref={(ref) => (this.container = ref)}
              className="toast-top-right"
            />
            {/* Main content */}
            <section className="content mx-2">
              <form className="form-horizontal">
                <div className="row mx-0">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="form-group row">
                          <label
                            htmlFor="remark"
                            className="col-sm-2 col-form-label justify-content-center"
                          >
                            Remark
                          </label>
                          <div className="col-sm-10">
                            <textarea
                              className="form-control"
                              rows="3"
                              placeholder="Enter..."
                              onChange={(e) => {
                                this.setState({ remark: e.target.value });
                              }}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      {/* /.card-body */}
                      <div className="card-footer">
                        <button
                          onClick={(e) => {
                            this._handleSubmit(e);
                          }}
                          type="submit"
                          className="btn btn-success float-right"
                        >
                          Save
                        </button>
                        <button
                          data-dismiss="modal"
                          className="btn btn-danger float-right mx-3"
                          id="close-button-reject"
                        >
                          Cancel
                        </button>
                      </div>
                      {/* /.card-footer */}
                    </div>
                    {/* /.card */}
                  </div>
                  {/* /.col */}
                </div>
                {/* /.row */}
              </form>
            </section>
          </div>
        </div>
        {/* /.modal-content */}
      </div>
    );
  }
}

export default withRouter(RejectModal);
